import { render, staticRenderFns } from "./AccessorialsGlobal.vue?vue&type=template&id=5257ffcd&scoped=true"
import script from "./AccessorialsGlobal.vue?vue&type=script&lang=js"
export * from "./AccessorialsGlobal.vue?vue&type=script&lang=js"
import style0 from "./AccessorialsGlobal.vue?vue&type=style&index=0&id=5257ffcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257ffcd",
  null
  
)

export default component.exports